import React from "react";
import Overview from "./Overview";
import Add from "./Add";
import Edit from "./Edit";
import Detail from "./Details";

import { PositionProvider } from "../../../context/PositionContext";

export const Restaurant = () => {
  return (
    
      <PositionProvider>
        <Overview />
      </PositionProvider>
    
  );
};

export const AddRestaurant = () => {
  return (
    
      
        <Add />
      
    
  );
};

export const EditRestaurant = () => {
  return (
    
      
        <Edit />
      
    
  );
};

export const ViewRestaurant = () => {
  return (
    
      <Detail />
    
  );
};
